import { ArrowBackIosNew, ArrowForward } from '@mui/icons-material'
import { Box, BoxProps, IconButton, Typography, useMediaQuery } from '@mui/material'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import theme from 'styles/theme'

// Desktop-only back + title row shown inside the Offer layout's white card.
export const OfferDesktopHeader: FC<{ label: string }> = ({ label }) => {
  const navigate = useNavigate()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

  if (!isDesktop) {
    return null
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', mb: '16px' }}>
      <IconButton size='small' onClick={() => navigate(-1)}>
        <ArrowBackIosNew sx={{ fontSize: '16px', color: theme.r4r.navy }} />
      </IconButton>
      <Typography sx={{ fontSize: '18px', fontWeight: 700, color: theme.r4r.navy }}>
        {label}
      </Typography>
    </Box>
  )
}

export const OfferButton: FC<BoxProps> = ({ children, sx, onClick, ...props }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'right',
        color: '#527EF7',
        width: '100%',
        ...sx
      }}
      onClick={onClick as any}
      {...props}>
      <Typography variant='body2' fontWeight={700} fontSize={15} textTransform='uppercase'>
        {children}
      </Typography>
      <IconButton size='small'>
        <ArrowForward color='primary' />
      </IconButton>
    </Box>
  )
}
